<template>
    <!--
    <div v-if="grid" class="d-flex flex-column align-center ma-2" style="width: 100px;">
     
        <v-img v-if="file.IsMedia2" class="ma-2" :width="80" :src="file.Link">
        </v-img>
    
        <v-icon size="50"> {{ typeIcon() }}</v-icon>
        <p class="mb-0 fileText">{{ file.Name }}</p>
    </div>
    v-else
    -->
    <div style="width: 100%;">
        <v-list-item dense class="pr-3" style="min-height: 34px; max-width: 100%;" link @click.stop=""
            @click.self="openInNewTab()">
            <v-list-item-action class="ma-0 mr-2" @click.stop="">
                <v-simple-checkbox :ripple="false" :value="selected" :color="file.IsExternalContent ? '' : 'primary'"
                    :disabled="!selectable" @input="onToggleSelect" />
            </v-list-item-action>
            <v-list-item-icon class="my-auto mr-3" @click.stop="openInNewTab()">
                <!--  
            <v-img v-if="file.IsMedia2" class="ma-2" :width="80" :src="file.Link">
            </v-img>
            -->
                <v-icon size="20"> {{ typeIcon() }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="py-0" @click.stop="openInNewTab()">
                <v-list-item-title>
                    {{ file.Name }}
                </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="file.PublishToCustomer !== null" class="ma-0 mr-1">
                <v-progress-circular v-if="file.loadingTogglePublishToCustomer" size="18" width="1" indeterminate
                    color="primary">
                </v-progress-circular>
                <v-tooltip v-else bottom>
                    <template #activator="{ on }">
                        <v-btn v-on="on" x-small icon :color="file.PublishToCustomer ? 'secondary' : 'disabled'"
                            @click.stop="triggerTogglePublishToCustomer()">
                            <v-icon>{{ file.PublishToCustomer ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                        </v-btn>
                    </template>
                    <span>
                        {{ file.PublishToCustomer
                            ? $t('servicesystem.common_objects.document.currently_visible_for_customer')
                            : $t('servicesystem.common_objects.document.currently_not_visible_for_customer') }}
                    </span>
                </v-tooltip>
            </v-list-item-action>
            <v-list-item-action class="ma-0">
                <ActionMenu :actionList="actionlist" :parentcontext="thiscontext">
                </ActionMenu>
            </v-list-item-action>
        </v-list-item>
        <SendEmailDialog :externaltrigger="dialogtrigger" :saveFunction="executeSendEmail" :emailDto="emailDto">
        </SendEmailDialog>
    </div>
</template>


<script>
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import SendEmailDialog from "@/components/Dialogs/SendEmailDialog.vue";
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
    name: 'File',
    props: {
        grid: Boolean,
        file: Object,
        selected: { type: Boolean, default: false },
        selectable: { type: Boolean, default: true },
        entityName: { type: String, default: '' },
        defaultEmailTemplate: { type: Object, default: null },
    },
    components: {
        ActionMenu,
        SendEmailDialog,
    },
    mixins: [clientAPI],

    data() {
        return {
            DocumentTypes: {
                LINK: 1,
                FORM: 2,
                PARTDRAWING: 3,
            },
            thiscontext: this,
            dialogtrigger: 1,
            emailDto: null,
        };
    },

    methods: {
        parseLink(file) {
            var link = file.Link;
            if (file.IsExternalContent && !link.includes('http') && !link.includes('https')) {
                return 'https://' + link;
            }
            if (file.IsExternalContent) {
                return link;
            }
            else if (file.TypeId == 2) { //if type is form use form population endpoint
                return `${window.location.origin}/api2/Resource/Form?documentId=${file.Id}&userId=${this.userInfo.Id}&jobId=${this.jobId}`;
            }
            else {
                return `${window.location.origin}/api2/Resource?relativePath=${encodeURIComponent(link)}`;
            }
        },

        openInNewTab() {
            var link = this.parseLink(this.file);
            //console.log('Open', this.file, link);
            window.open(link, '_blank').focus();
        },

        typeIcon() {
            if (this.file.IsExternalContent) {
                return 'mdi-link-variant';
            }
            else if (this.file.IsMedia) {
                return 'mdi-file-image';
            }
            else if (this.file.TypeId == this.DocumentTypes.FORM) {
                return 'mdi-file-document-edit';
            }
            else if (this.file.TypeId == this.DocumentTypes.PARTDRAWING) {
                return 'mdi-file-cad';
            }
            else if (this.file.FileExtension) {
                switch (this.file.FileExtension) {
                    case '.ZIP':
                        return 'mdi-folder-zip';
                    case '.XLSX':
                    case '.CSV':
                        return 'mdi-microsoft-excel';
                    case '.DOCX':
                    case '.DOC':
                        return 'mdi-microsoft-word';
                    case '.PPTX':
                    case '.PPTM':
                        return 'mdi-microsoft-powerpoint';
                    default:
                        return 'mdi-file-document';
                }
            }
            else {
                return 'mdi-file-document';
            }
        },

        onToggleSelect(val) {
            this.$emit('ToggleSelect', { file: this.file, selected: !!val });
        },
        triggerEdit() {
            console.log('Edit');
        },
        triggerTogglePublishToCustomer() {
            this.$emit('TogglePublishToCustomer', this.file);
        },
        triggerDelete() {
            this.$emit('Delete', this.file);
        },
        triggerSendEmail() {
            this.initiateSend();
        },
        initiateSend() {
            // Skip external content
            if (this.file?.IsExternalContent) { return; }
            const normalizedEntity =
                this.entityName === 'MachineJobHistory' ? 'Job' : this.entityName;
            const attachments = [{
                entityClass: normalizedEntity,
                documentTypeId: Number(this.file?.TypeId),
                documentId: Number(this.file?.Id),
            }];
            this.emailDto = {
                CustomerId: this.defaultEmailTemplate?.CustomerId || this.customerId || null,
                To: this.defaultEmailTemplate?.To || "",
                Subject: this.defaultEmailTemplate?.Subject || "",
                Body: this.defaultEmailTemplate?.Body || "",
                CC: this.defaultEmailTemplate?.CC || "",
                Attachments: attachments,
            };
            this.dialogtrigger++;
        },
        async executeSendEmail(dto) {
            await this.sendEmail(dto);
        },
    },

    computed: {
        actionlist() {
            var list = [
                //{ '#': 1, title: 'Edit', icon: "mdi-pencil", iconsize: 22, hovercolor: "tertiary", method: "triggerEdit" },
                { '#': 1, title: 'Send email', icon: "mdi-email-edit", iconsize: 22, hovercolor: "primary", method: "triggerSendEmail", disabled: !!this.file?.IsExternalContent },
                { '#': 2, title: 'Delete', icon: "mdi-delete", iconsize: 22, hovercolor: "error", method: "triggerDelete" },
            ];
            return list;
        },

        jobId() {
            return this.$route.params?.jobId || 0;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped>
.fileText {
    font-size: 12px;
    opacity: 0.9;
    overflow-wrap: break-word;
    inline-size: 100px;
    line-clamp: 3;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-align: center;
}
</style>